import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const radpairPlugin = createPlugin({
  id: 'radpair',
  routes: {
    root: rootRouteRef,
  },
});

export const RadpairPage = radpairPlugin.provide(
  createRoutableExtension({
    name: 'RadpairPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.RadpairIframe),
    mountPoint: rootRouteRef,
  }),
);
